module.exports = __webpack_public_path__ + "img/pocket width welt.ae8e0ccd.png";